import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  cashierFlowEntityList: [],
  cashierFlowEntityInfo: {
    entityId: '',
    entityName: '',
    entityDesc: '',
    entityContact: '',
    projId: '',
    compId: '',
    seq: 0,
    status: '',
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  editAction: '',
  cashierFlowEntityDDList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertCashierFlowEntity({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_CASHIER_FLOW_ENTITY, {
      data: {
        entityName: state.cashierFlowEntityInfo.entityName,
        entityDesc: state.cashierFlowEntityInfo.entityDesc,
        entityContact: state.cashierFlowEntityInfo.entityContact,
        // status: state.cashierFlowEntityInfo.status,
        //
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateCashierFlowEntity({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    let cashierFlowEntityInfo = {
      entityName: state.cashierFlowEntityInfo.entityName,
      entityDesc: state.cashierFlowEntityInfo.entityDesc,
      entityContact: state.cashierFlowEntityInfo.entityContact,
      // status: state.cashierFlowEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_CASHIER_FLOW_ENTITY, {
      data: cashierFlowEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeCashierFlowEntity({
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_CASHIER_FLOW_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  // async findCashierFlowEntity({
  //   commit
  // }, {entityId, projId, compId}) {
  //   const responseData = await getReq(END_POINTS.FIND_CASHIER_FLOW_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
  //     headerMap: await getCPHeaderMap(compId, projId)
  //   })
  //   if (responseData.success) {
  //     commit('updateCashierFlowEntityInfo', responseData.data)
  //   } else {
  //     commit('updateCashierFlowEntityInfo', {})
  //   }
  // },
  async findCashierFlowEntityList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_CASHIER_FLOW_ENTITY_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateCashierFlowEntityList', response)
  },
  async findCashierFlowEntityDDList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_CASHIER_FLOW_ENTITY_DD_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateCashierFlowEntityDDList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateEntityId(state, value) {
    state.cashierFlowEntityInfo.entityId = value
  },
  updateEntityName(state, value) {
    state.cashierFlowEntityInfo.entityName = value
  },
  updateEntityDesc(state, value) {
    state.cashierFlowEntityInfo.entityDesc = value
  },
  updateEntityContact(state, value) {
    state.cashierFlowEntityInfo.entityContact = value
  },
  updateProjId(state, value) {
    state.cashierFlowEntityInfo.projId = value
  },
  updateCompId(state, value) {
    state.cashierFlowEntityInfo.compId = value
  },
  updateSeq(state, value) {
    state.cashierFlowEntityInfo.seq = value
  },
  updateStatus(state, value) {
    state.cashierFlowEntityInfo.status = value
  },
  updateCrtBy(state, value) {
    state.cashierFlowEntityInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.cashierFlowEntityInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.cashierFlowEntityInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.cashierFlowEntityInfo.updOn = value
  },
  updateCashierFlowEntityDDList(state, response) {
    if (response.success === true && response.data.length) {
      state.cashierFlowEntityDDList = Utils.toListWapper(response.data, {valueField: 'entityId', descrField: 'entityName'})
    } else {
      state.cashierFlowEntityDDList = []
    }
  },
  updateCashierFlowEntityList(state, response) {
    if (response.success === true && response.data.length) {
      state.cashierFlowEntityList = response.data
    } else {
      state.cashierFlowEntityList = []
    }
  },
  updateCashierFlowEntityListEmpty(state) {
    state.editIndex = -1
    state.cashierFlowEntityList = []
  },
  updateCashierFlowEntityEmpty(state) {
    state.cashierFlowEntityInfo.entityId = ''
    state.cashierFlowEntityInfo.entityName = ''
    state.cashierFlowEntityInfo.entityDesc = ''
    state.cashierFlowEntityInfo.entityContact = ''
    state.cashierFlowEntityInfo.projId = ''
    state.cashierFlowEntityInfo.compId = ''
    state.cashierFlowEntityInfo.seq = 0
    state.cashierFlowEntityInfo.status = ''
    state.cashierFlowEntityInfo.crtBy = ''
    state.cashierFlowEntityInfo.crtOn = new Date(0)
    state.cashierFlowEntityInfo.updBy = ''
    state.cashierFlowEntityInfo.updOn = new Date(0)

    state.cashierFlowEntityInfo.indUsed = ''
  },
  updateCashierFlowEntityInfo(state, cashierFlowEntityInfo) {
    // debugger
    state.cashierFlowEntityInfo.entityId = cashierFlowEntityInfo.entityId
    state.cashierFlowEntityInfo.entityName = cashierFlowEntityInfo.entityName
    state.cashierFlowEntityInfo.entityDesc = cashierFlowEntityInfo.entityDesc
    state.cashierFlowEntityInfo.entityContact = cashierFlowEntityInfo.entityContact
    state.cashierFlowEntityInfo.projId = cashierFlowEntityInfo.projId
    state.cashierFlowEntityInfo.compId = cashierFlowEntityInfo.compId
    state.cashierFlowEntityInfo.seq = cashierFlowEntityInfo.seq
    state.cashierFlowEntityInfo.status = cashierFlowEntityInfo.status
    state.cashierFlowEntityInfo.crtBy = cashierFlowEntityInfo.crtBy
    state.cashierFlowEntityInfo.crtOn = cashierFlowEntityInfo.crtOn
    state.cashierFlowEntityInfo.updBy = cashierFlowEntityInfo.updBy
    state.cashierFlowEntityInfo.updOn = cashierFlowEntityInfo.updOn
    //
    state.cashierFlowEntityInfo.indUsed = cashierFlowEntityInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('confCashierFlowEntityManage/updateCashierFlowEntityEmpty')
    let obj = {...state.cashierFlowEntityInfo}
    // debugger
    obj.isBottomRow = true
    state.cashierFlowEntityList.push(obj)
  },
  handleAdd(state, {row, index}) {
    // debugger
    this.commit('confCashierFlowEntityManage/updateCashierFlowEntityEmpty')
    this.commit('confCashierFlowEntityManage/updateEditIndex', index)
    this.commit('confCashierFlowEntityManage/updateEditAction', 'insert')
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('confCashierFlowEntityManage/updateCashierFlowEntityInfo', row)
    this.commit('confCashierFlowEntityManage/updateEditIndex', index)
    this.commit('confCashierFlowEntityManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/confCashierFlowEntityManage.js